export function getIconForStatus(status: string) {
    if (status === 'passed') {
        return 'check-circle';
    } else if (status === 'warning') {
        return 'exclamation-circle';
    } else {
        return 'close-circle';
    }
}

export function formatTimestamp(timestamp: number) {
    const options = { year: 'numeric' as const, month: 'short' as const, day: 'numeric' as const };

    let lastCheckedDate = new Date(timestamp * 1000);

    return lastCheckedDate.toLocaleDateString('en-US', options);
}

export function getGoogleSearchUrl(searchKeywords: string) {
    return `https://www.google.com/search?q=${encodeURIComponent(searchKeywords)}`;
}

export function countOfListElements(obj: { [key: string]: any[] }) {
    return Object.values(obj).reduce((acc, cur) => {
        return acc + cur.length;
    }, 0);
}

export function isObject(value: any) {
    return value && typeof value === 'object' && value.constructor === Object;
}

export function getUrl(domain: string) {
    return `http://${domain}`;
}

export function anchorAttributesForUrls(urlList: string[]) {
    return urlList.map((url) => ({
        anchorLabel: url,
        target: '_blank',
    }));
}

export function anchorAttributesAndLabelForUrls(listOfUrlsObject: any[]) {
    return listOfUrlsObject.map((item) => ({
        anchorLabel: item.url,
        label: item.cdn,
        target: '_blank',
    }));
}
